<div>
  <h4 class="header-title">Enter Balances</h4>
  <p>
    Listed below are the available recombinations for this deal. Enter the amounts for the exchanges
    you’d like to make in the fields below. Once finished, select a settlement date and click the
    “Calculate Fees” button to see the fees and review your exchange.
  </p>
</div>
<div class="enter-balances-table-container container-fluid">
  <div class="row deal-number-or-cusip-container {{ SMBS_FLOW ? '' : 'remic' }}">
    <div class="col-md-1 deal-number-icon">
      <i class="fa fa-file-text-o deal-header-icon" aria-hidden="true"></i>
    </div>
    <div class="col-md-5 deal-number-container">
      <div class="deal-number">Deal Number</div>
      <div class="deal-number-or-cusip">{{ dealNumberOrCusip }}</div>
    </div>
    <div class="col-md-6 prospectus-supplement-container">
      <div class="recom-number">
        {{
          SMBS_FLOW
            ? recombinationExchangeResponse?.recombinations?.recombinations[0]?.recombinationRows
                ?.length + ' Available Bonds'
            : recombinationExchangeResponse?.recombinations?.recombinations?.length +
              ' Available Recombinations'
        }}
      </div>
      <div class="prospectus-link">
        <a href="{{ prospectSupplURL }}" target="_blank">View Prospectus</a>
      </div>
    </div>
  </div>

  <div>
    <invd-enter-balances-recombinations-table
      [recombinationExchange]="recombinationExchangeResponse"
      [isSmbsFlow]="SMBS_FLOW"
      [isSmbsClearBtnClick]="clearBtnClick"
      [recombinationTableExchangeType]="exchangeType"
      [isExternalUser]="!userService.isInternalUser"
      [isFromTakedownPage]="RCR_FLOW_AT_SETTLEMENT_TAKEDOWNS"
      (startedEditing)="onAnyRowStartedEditing()"
      class="recombination-table-container"
    >
    </invd-enter-balances-recombinations-table>
  </div>
</div>

<div class="SMBS-model-window" *ngIf="SHOW_MODAL_WINDOW">
  <div class="panel panel-default">
    <div class="panel-body">
      <invd-enter-balances-interest-review-error
        [statusDisplayMessage]="statusDisplayMessage"
        [statusResolutionMessage]="statusResolutionMessage"
        [modalHasStatusSuccess]="MODAL_HAS_STATUS_SUCCESS"
        [modalHasStatusError]="MODAL_HAS_STATUS_ERROR"
        [principalMismatch]="SMBS_FLOW_PRINCIPAL_MISMATCH"
        [interestMismatch]="SMBS_FLOW_INTEREST_MISMATCH"
        [SMBSFlowModifyExchange]="SMBS_FLOW_MODIFY_EXCHANGE"
        [netExchangeViews]="netExchangeViews"
        [isRCRFLOW]="RCR_FLOW"
        [totalErrorCount]="totalErrorCount"
        [rcrCalcFeeErrorRes]="rcrCalcFeeErrorRes"
        [rcrRemicDealType]="rcrRemicDealType"
        (buttonClicked)="dismissPoupMessageWindow()"
      >
      </invd-enter-balances-interest-review-error>
    </div>
  </div>
</div>

<!--<invd-sticky-input-toolbar
  (buttonClicked)="onStickyBarButtonClick()"
  (clearButtonClicked)="onStickyBarClearButtonClick()">
</invd-sticky-input-toolbar>-->

<ng-container *ngIf="isDateMsgHidden">
  <div class="enter-mega-model-window">
    <div class="panel panel-default fadeInUpBig">
      <button
        type="button"
        class="close float-end"
        aria-label="Close"
        (click)="isDateMsgHidden = !isDateMsgHidden"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="panel-body mega-cancel-confirmation-model">
        <h4>The market closes early on the day you chose.</h4>
        <br />
        <p>
          Please be sure staff is available to complete this transaction or select a different
          settlement date before proceeding to the next step.
        </p>
        <br />
        <button class="button fm-primary-button" (click)="isDateMsgHidden = !isDateMsgHidden">
          OK
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showBannerExitIconNavigationPopup">
  <div class="enter-mega-model-window">
    <div class="panel panel-default fadeInUpBig">
      <button
        type="button"
        class="close float-end"
        aria-label="Close"
        (click)="showBannerExitIconNavigationPopup = !showBannerExitIconNavigationPopup"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="panel-body">
        <h4 class="bannerExitIconNavPopupTextAlign">
          You are about to stop acting on behalf of this user
        </h4>
        <br />
        <p class="bannerExitIconNavPopupTextAlign">
          Please be advised by doing so, any work you have done to this point for the user that has
          not already been saved will be lost.
        </p>
        <br />
        <div class="bannerExitIconNavPopupButtonAlign">
          <button
            class="button fm-tertiary-button"
            (click)="showBannerExitIconNavigationPopup = !showBannerExitIconNavigationPopup"
          >
            NEVERMIND
          </button>
          <button class="button fm-primary-button" (click)="goToRCRRequestExchangePage()">
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<invd-rcr-exchange-sticky-footer [footerContent]="stickFooterComponents">
</invd-rcr-exchange-sticky-footer>
